<script setup lang="ts">

//vue
import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/BoletosService";
import {  fdata, f2dec,} from "@/utils/funcoes";

var emit = defineEmits(['filtrar']);

interface IProps {
    itens: service.RetornoPorStatusDto[];
    ocorrenciaId: string;
    
}

interface IGrupo {
    id: string;
    descricao: string;
    qtde: number;
    valorUnit: number;
    valorTotal: number;
    valorTotalDoctos: number;
    itens: service.RetornoPorStatusDto[];
}

var props = defineProps<IProps>();

var controle = reactive({
    ocorrenciaId: props.ocorrenciaId,
    itens: [] as service.RetornoPorStatusDto[],
    model: {} as service.RetornoPorStatusDto,
    processando: false
});

onMounted(() => {
    controle.itens = props.itens;
})

watch(() => props.itens ,(newVal) => {
    controle.itens = newVal;
    controle.model = {} as service.RetornoPorStatusDto;
});

watch(() => props.ocorrenciaId ,(newVal) => {
    controle.ocorrenciaId = newVal;
});

function filtrar(item: service.RetornoPorStatusDto){
    controle.model = item;
    emit('filtrar', item);
}


</script>

<template>
    <div class="col-md-12 col-12 fs-6 fw-bold">
        Resumo por Status
    </div>

    <table class="table table-sm table-bordered">
        <thead>
            <tr>
                <!-- <th>Cód</th> -->
                <th>Descrição</th>
                <th class="text-end">Qtde</th>
                <th class="text-end">Total R$</th>
            </tr>
        </thead>
        <tbody>
            <template v-for="(item, index) in controle.itens" :key="index" >
                <tr v-if="controle.ocorrenciaId == item.ocorrenciaId" @click="filtrar(item)" 
                :class="item.statusProcessamento == controle.model.statusProcessamento ? 'table-active' : ''"
                style="cursor: pointer;">
                <!-- <td>{{ item.id }}</td> -->
                <td>{{ item.statusProcessamento }}</td>
                <td class="text-end">{{ item.qtde }}</td>
                <td class="text-end">{{ f2dec(item.valorDocumento) }}</td>
            </tr>
        </template>
        </tbody>
        <tfoot>
            <tr class="fw-bold">
                <td>Total</td>
                <td class="text-end">{{ controle.itens.reduce((acc, item) => acc + item.qtde, 0) }}</td>
                <td class="text-end">{{ f2dec(controle.itens.reduce((acc, item) => acc + item.valorDocumento, 0)) }}</td>
            </tr>
        </tfoot>
    </table>
</template>

<style scoped>

</style>